import { _ } from "~/route/globals";
import { buildRadioCheck, node } from "~/util/dom";
import { ROUTE_CONST } from "~/route/const";
import { standardDistanceFormat } from "~/util/format";

export function createParamsItemTollItem(data, withDistance) {
	const excludeCountries = Mapy.CML.state.route.params.excludeCountries;
	const criterion = Mapy.CML.state.route.params.criterion;

	const item = node("li", { className: "checkbox-item" });
	// checkbox
	const rcData = buildRadioCheck("checkbox", "", "");

	if (criterion === ROUTE_CONST.types.car.criterion[0] || criterion === ROUTE_CONST.types.car.criterion[2]) {
		rcData.input.checked = excludeCountries.filter(function filterCountry(iso3) {
			return iso3 === data.iso3;
		}).length === 1;
	} else {
		rcData.input.checked = true;
	}

	// nazev a vyhnu se km
	const title = node("p", { className: "title", textContent: data.name });

	rcData.title.appendChild(title);

	if (withDistance) {
		let avoidTxt = "";

		if (data.ignore) {
			// FIXME: az bude slovnik, tak nechat jen notOnRoute
			avoidTxt = _("route.params.notOnRoute") === "route.params.notOnRoute" ? _("route.params.avoidDistance") : _("route.params.notOnRoute");
		} else if (rcData.input.checked) {
			avoidTxt = _("route.params.avoidDistance");
		} else if (data.payedLength > 0) {
			avoidTxt = _("route.params.paidDistance", {
				count: standardDistanceFormat(data.payedLength).string,
				all: standardDistanceFormat(data.totalLength).string,
			});
		} else {
			avoidTxt = _("route.params.paidZeroDistance");
		}

		rcData.title.appendChild(node("p", { className: "avoid", innerHTML: avoidTxt }));
	} else {
		item.classList.add("last-choice");
	}

	item.appendChild(rcData.label);
	// vlajka
	const flagArea = node("span", { className: "flag-area" });
	const flagCover = node("span", { className: "flag-cover" });

	flagCover.style.backgroundImage = `url(/img/flags/${data.iso3.toLowerCase()}.png)`;
	flagArea.appendChild(flagCover);
	item.appendChild(flagArea);

	return {
		li: item,
		input: rcData.input,
	};
}
